import type { GeniusPlayStart, Quiz } from '../services/api';
import { GENIUS_TOTAL_ROUNDS } from './geniusPlayScoring';

export { GENIUS_TOTAL_ROUNDS };

export function isGeniusQuizFormat(quiz: Quiz): boolean {
  const f = (quiz.format || '').toString();
  return f === 'Genius' || f === 'genius';
}

export function parseGeniusPlayStart(raw: unknown): GeniusPlayStart | null {
  if (!raw || typeof raw !== 'object') return null;
  const d = raw as Record<string, unknown>;
  const panelRaw = (d.panel ?? d.Panel) as unknown;
  if (!Array.isArray(panelRaw) || panelRaw.length === 0) return null;

  const panel = panelRaw.map((p) => {
    const row = p as Record<string, unknown>;
    return {
      questionId: String(row.questionId ?? row.QuestionId ?? ''),
      imageAssetKey: String(row.imageAssetKey ?? row.ImageAssetKey ?? ''),
      soundAssetKey: String(row.soundAssetKey ?? row.SoundAssetKey ?? ''),
      label: (row.label ?? row.Label ?? null) as string | null,
    };
  });

  const roundsRaw = (d.rounds ?? d.Rounds) as unknown;
  const rounds = Array.isArray(roundsRaw)
    ? roundsRaw.map((r) =>
        Array.isArray(r) ? r.map((id) => String(id)) : []
      )
    : [];

  const playSessionId = String(d.playSessionId ?? d.PlaySessionId ?? '');
  if (!playSessionId) return null;

  return {
    playSessionId,
    panel,
    rounds,
    totalRounds: Number(d.totalRounds ?? d.TotalRounds) || GENIUS_TOTAL_ROUNDS,
    engineBootstrapCipher: (d.engineBootstrapCipher ?? d.EngineBootstrapCipher ?? null) as string | null,
  };
}
